import { render, staticRenderFns } from "./AccountInformationDetails.vue?vue&type=template&id=6bfc4900&scoped=true&"
import script from "./AccountInformationDetails.vue?vue&type=script&lang=ts&"
export * from "./AccountInformationDetails.vue?vue&type=script&lang=ts&"
import style0 from "./AccountInformationDetails.vue?vue&type=style&index=0&id=6bfc4900&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6bfc4900",
  null
  
)

export default component.exports